module.exports = __webpack_public_path__ + "static/media/mainbanner.34781a37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/mainbanner.jpg
// module id = 121
// module chunks = 0